<template>
	<div>
		<el-upload :limit="200" ref="upload" class="upload-demo" action="" :auto-upload="true" :on-preview="handlePreview"
			:on-remove="handleRemove" :on-change="onChange" :http-request="httpRequest" multiple :file-list="fileList">
			<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
			<!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
			<el-button style="margin-left: 10px;" size="small" type="success" @click="again">重试</el-button>
			<div class="el-upload__tip" slot="tip">进度：{{success.length}}/{{fileList.length}} （一次最多200）</div>
		</el-upload>
	</div>
</template>
<style>

</style>
<style scoped>
	.item {
		margin-bottom: 4px;
	}
</style>
<script>
	import OSS from 'ali-oss';
	const client = new OSS({
		region: 'oss-cn-hangzhou',
		accessKeyId: 'LTAI5tFdHZVMtBtiJUa2xEgJ',
		accessKeySecret: 'LERxsvzYzq1JaYRHdIs6m93rFbePm4',
		bucket: 'nazhi',
		secure: true
	});
	export default {
		name: 'invoiceuploadIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				fileList: [],
				success: [],
				fail: [],
				num: 0
			}
		},
		watch: {

		},
		created() {


		},
		mounted() {

		},
		computed: {

		},

		methods: {
			again() {
				this.fail.forEach((item)=>{
					this.httpRequest(item)
				})
			},
			httpRequest(e) {
				
				let name = 'fapiao/' + this.getFileName(e.file)
				client.put(name, e.file).then(() => {
					//let invoicecode = e.file.name.split('.')[0]
					this.onSuccess(e)
				}).catch(() => {
					this.onFail(e)
				})
			},
			onChange(file, fileList) {
				file.name = this.getFileName(file)
				this.fileList = fileList
			},
			onSuccess(e) {
				this.success.push(e)
				let name = this.getFileName(e.file)
				name = name.split('.')
				this.$api.invoiceoutput.uploadfile(name[0])
				this.checkFail()
			},
			onFail(e) {
				let obj = this.fail.find((item) => {
					return item.file.name == e.file.name
				})
				if (!obj) {
					this.fail.push(e)
				}
	
			},
			checkFail(){
				let fail = []
				this.fail.forEach((fitem) => {
					let obj = this.success.find((sitem) => {
						return fitem.file.name == sitem.file.name
					})
					if(!obj){
						fail.push(fitem)
					}
				})
				this.fail = fail
			},
			handleRemove(file, fileList) {
				console.log(file, fileList)
			},
			handlePreview(file) {
				console.log(file)
			},
			// handleExceed(files, fileList) {
			// 	this.$message.warning()
			// },
			beforeRemove(file) {
				return this.$confirm(`确定移除 ${ file.name }？`)
			},
			getFileName(file){
				let type = 0
				let name = ''
				let arr = []
				if(file.name.indexOf('_')!=-1){
					arr = file.name.split('_')
					type = 1
				}else if(file.name.indexOf('-')!=-1){
					arr = file.name.split('-')
					type = 2
				}else{
					name = file.name
				}
				if(type==1){
					let suffix = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)
					if(file.name.startsWith('dzfp')){
						name = arr[1]+'.'+suffix
					}else{
						name = arr[0]+'.'+suffix
					}
				}else if(type==2){
					name = arr[1]
				}
				console.log(name)
				return name
				
			}
		},
		components: {

		}
	}
</script>
